import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store/types/store";
import { fetchPaymentRequestsListRequest } from "../../store/slices/payment-slice";
import { PAGE_LIMIT } from "../../constants";
import { ListTable } from "../../components/ListTable";
import {formatDate} from "../../utility/general";

const PaymentRequests = () => {
  const dispatch: AppDispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(PAGE_LIMIT);
  const [statusFilter, setStatusFilter] = useState("");

  const { payment_list, loading, pagination, error } = useSelector(
    (state: RootState) => state.payment,
  );

  const payload = {
    page: page,
    limit: limit,
    status: statusFilter,
  };

  useEffect(() => {
    dispatch(fetchPaymentRequestsListRequest(payload));
  }, [page, statusFilter]);

  const columns = [
    { key: "appName", label: "Product" },
    { key: "productName", label: "Plan" },
    { key: "customerName", label: "Customer Name" },
    { key: "customerEmail", label: "Customer Email" },
    { key: "paymentData", label: "Amount", render: (item: any) => (
          item.paymentData?.amount
      ) },
    { key: "createdAt", label: "Date", render: (item: any) => (
          formatDate(item.createdAt)
      ) },
    {
      key: "statusMessage",
      label: "Status",
      render: (item: any) => (
        <span
          className={`${
            item.status === "complete"
              ? "status-active"
              : item.status === "rejected"
                ? "status-inactive"
                : "status-pending"
          }`}
        >
          {item.status}
        </span>
      ),
    },
  ];

  return (
    <ListTable
      columns={columns}
      title={"Payment Requests Information"}
      page={page}
      setPage={setPage}
      statusFilter={statusFilter}
      loading={loading}
      pagination={pagination}
      error={error}
      list={payment_list}
      setStatusFilter={setStatusFilter}
    />
  );
};

export default PaymentRequests;
